module.exports = __webpack_public_path__ + "img/北京冷库 (1).fa857f66.jpg";